import React from "react";
import "./Home.css";

export default function Home() {
    return (
        <section id="home">
            <div className="overlay">
                <div className="content">
                    <h1>Hi, my name is David "Trey" Hollins</h1><br />
                    <p>I'm a software engineering graduate currently looking for an entry level software developer position.</p>
                </div>
            </div>
        </section>
    );
}